import './typography.css'

export const Heading2 = ({ children, className }) => {
  return (
    <div className={'heading2 ' + (className ? className : '')}>{children}</div>
  )
}
export const Heading3 = ({ children, className }) => {
  return (
    <div className={'heading3 ' + (className ? className : '')}>{children}</div>
  )
}

export const Heading4 = ({ children, className }) => {
  return (
    <div className={'heading4 ' + (className ? className : '')}>{children}</div>
  )
}
export const Heading5 = ({ children, className }) => {
  return (
    <div className={'heading5 ' + (className ? className : '')}>{children}</div>
  )
}
export const TextRegular1 = ({ children, className }) => {
  return (
    <div className={'text-regular-1 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextRegular7 = ({ children, className }) => {
  return (
    <div className={'text-regular-7 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextRegular = ({ children, className }) => {
  return (
    <div className={'text-regular ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextBold2 = ({ children, className }) => {
  return (
    <div className={'text-bold-2 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextBold3 = ({ children, className }) => {
  return (
    <div className={'text-bold-3 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextBold11 = ({ children, className }) => {
  return (
    <div className={'text-bold-11 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextBold12 = ({ children, className }) => {
  return (
    <div className={'text-bold-12 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextBold4 = ({ children, className }) => {
  return (
    <div className={'text-bold-4 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextBold5 = ({ children }, className) => {
  return (
    <div className={'text-bold-5 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextBold6 = ({ children, className }) => {
  return (
    <div className={'text-bold-6 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextBold7 = ({ children, className }) => {
  return (
    <div className={'text-bold-7 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextBold8 = ({ children, className }) => {
  return (
    <div className={'text-bold-8 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextBold9 = ({ children, className }) => {
  return (
    <div className={'text-bold-9 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextBold10 = ({ children, className }) => {
  return (
    <div className={'text-bold-10 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextRegular2 = ({ children, className }) => {
  return (
    <div className={'text-regular-2 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextRegular4 = ({ children, className }) => {
  return (
    <div className={'text-regular-4 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextRegular5 = ({ children, className }) => {
  return (
    <div className={'text-regular-5 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextRegular6 = ({ children, className }) => {
  return (
    <div className={'text-regular-6 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextRegular8 = ({ children, className }) => {
  return (
    <div className={'text-regular-8 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextRegular3 = ({ children, className }) => {
  return (
    <div className={'text-regular-4 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const TextBold1 = ({ children, className }) => {
  return (
    <div className={'text-bold-1 ' + (className ? className : '')}>
      {children}
    </div>
  )
}
export const Underline = ({ children, className }) => {
  return (
    <div className={'underline-normal-text ' + (className ? className : '')}>
      {children}
    </div>
  )
}
